import React from 'react';
import OptionsCommon from 'components/quote_builder_widget/form/options/OptionsCommon.jsx';

const OptionLengthWithUnit = ({ id, drawing, option, unit }) => {
  const formattedValue = (value) => {
    let toFormat = parseFloat(value);
    let formatted = (Number.isNaN(toFormat) ? 0 : toFormat).toFixed(
      unit === 'in' ? 4 : 2
    );

    return formatted;
  };

  const [isVisible, value, onChange, highlighted] = OptionsCommon({
    formattedValue,
    id,
    drawing,
    option,
    unit,
  });

  const formatValueDecimal = (e) => {
    let formattedValueRes = formattedValue(e.target.value);
    onChange({ target: { value: formattedValueRes } });
  };

  return (
    <div className="mb-3" data-widget-element="form-group">
      <div className="input-group">
        <span className="input-group-text font13" data-widget-element="label">{option.presented_name}</span>
        <input
          type="text"
          name={option.name}
          className="form-control text-align-right"
          value={value}
          onChange={onChange}
          onBlur={formatValueDecimal}
          readOnly={option.readonly}
          autoComplete="off"
          data-widget-element="input"
          data-has-suffix="true"
        />
        <span className="input-group-text font13" data-widget-element="unit-suffix">{unit}</span>
      </div>
    </div>
  );
};

export default OptionLengthWithUnit;
